import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Lock, Mail, ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function AdminLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login, isAuthenticated, loading: authLoading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!authLoading && isAuthenticated) {
      navigate('/admin/dashboard');
    }
  }, [isAuthenticated, authLoading, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await login(email, password);
      navigate('/admin/dashboard');
    } catch (err) {
      setError('Invalid credentials. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (authLoading) {
    return (
      <div className="min-h-screen bg-obsidian flex items-center justify-center">
        <div className="spinner" />
      </div>
    );
  }

  return (
    <div data-testid="admin-login-page" className="min-h-screen bg-obsidian flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        {/* Back Link */}
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-gray-400 hover:text-gold mb-8 transition-colors"
          data-testid="back-to-home"
        >
          <ArrowLeft size={16} />
          <span className="text-sm">Back to Website</span>
        </Link>

        {/* Login Card */}
        <div className="bg-obsidian-paper border border-white/5 p-6 sm:p-8 md:p-10">
          {/* Logo */}
          <div className="flex items-center justify-center mb-6 sm:mb-8">
            <div className="w-10 h-10 sm:w-12 sm:h-12 bg-primary flex items-center justify-center">
              <span className="text-white font-heading font-bold text-xl sm:text-2xl">A</span>
            </div>
          </div>

          <h1 className="font-heading text-xl sm:text-2xl md:text-3xl font-bold text-white text-center mb-2">
            Admin Access
          </h1>
          <p className="text-gray-400 text-center text-sm sm:text-base mb-6 sm:mb-8">
            Sign in to manage your content
          </p>

          <form onSubmit={handleSubmit} data-testid="login-form">
            <div className="space-y-5 sm:space-y-6">
              {/* Email */}
              <div className="relative">
                <Mail className="absolute right-0 top-1/2 -translate-y-1/2 w-4 h-4 sm:w-5 sm:h-5 text-gray-500" />
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Email Address"
                  required
                  className="input-dark w-full pl-7 sm:pl-8 text-sm sm:text-base"
                  data-testid="login-email"
                />
              </div>

              {/* Password */}
              <div className="relative">
                
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Password"
                  required
                  className="input-dark w-full pl-7 sm:pl-8 text-sm sm:text-base"
                  data-testid="login-password"
                />
                <Lock className="absolute right-0 top-1/2 -translate-y-1/2 w-4 h-4 sm:w-5 sm:h-5 text-gray-500" />
              </div>

              {error && (
                <div className="text-red-500 text-sm text-center" data-testid="login-error">
                  {error}
                </div>
              )}

              <button
                type="submit"
                disabled={loading}
                className="btn-primary w-full flex items-center justify-center gap-2 disabled:opacity-50"
                data-testid="login-submit"
              >
                {loading ? (
                  <div className="spinner" />
                ) : (
                  'Sign In'
                )}
              </button>
            </div>
          </form>

          {/* Hint */}
         
        </div>
      </div>
    </div>
  );
}
